const TextPreview = ({ preview }) => {
    const { data } = preview;
    return (
        <div className="text-preview">
            <pre>{data}</pre>
        </div>
    );
}

export default TextPreview;
